import axios from "axios";
import { GalleryImage } from "../Gallery/Gallery";
import { config } from "../Map/config";
import { ImageLoadingState } from "../Map/enums";
interface IRelatedImage {
    fileName: string;
    storedFileName: string;
    title?: string;
    description?: string;
}

const relatedImagesCache: Record<number, IRelatedImage[]> = {};
const promises: Record<number, Promise<IRelatedImage[]>> = {};

export const getThumbnailUrl = async (objectId: number): Promise<string> => {
    const respData = relatedImagesCache[objectId] || (await getRelatedImages(objectId));
    if (!respData) {
        return "";
    }
    if (!respData.length) {
        return ImageLoadingState.NoImages;
    }

    const url =
        config.dataView.imageApi +
        "/api/GetImage?file=" +
        respData[0].storedFileName +
        "&height=" +
        (config.dataView.thumbnailHeight || 30);
    return url;
};

export const getRelatedImagesUrls = async (objectId: number): Promise<GalleryImage[]> => {
    const respData = relatedImagesCache[objectId] || (await getRelatedImages(objectId));
    if (!respData || !respData.length) {
        return [];
    }
    return respData.map((image: IRelatedImage) => {
        const baseUrl = config.dataView.imageApi;
        return {
            original: baseUrl + "/api/GetImage?file=" + image.storedFileName + "&height=" + 200,
            thumbnail:
                baseUrl +
                "/api/GetImage?file=" +
                image.storedFileName +
                "&height=" +
                (config.dataView.thumbnailHeight || 30),
            fullscreen: baseUrl + "/api/GetImage?file=" + image.storedFileName
        } as GalleryImage;
    });
};

const getRelatedImages = (objectId: number): Promise<IRelatedImage[]> => {
    if (!promises[objectId]) {
        promises[objectId] = axios
            .get(config.dataView.imageApi + "/api/GetRelatedImages", {
                params: {
                    RelatedObjectId: objectId,
                    Layer: "PUBSDE.LandPlotCatalog"
                }
            })
            .then((resp) => {
                relatedImagesCache[objectId] = resp.data;
                return resp.data;
            })
            .catch((error) => {
                console.log("no related images for " + objectId + " " + error);
                return [];
            });
    }

    return promises[objectId];
};
